window.Overview = function () {
    /***********************************************************
    GALLERY
    ***********************************************************/
    $slick_slider = $('.GalleryContent');

    $slick_slider.on('init reInit afterChange', function (event, slick) {
        if (slick.slideCount < 3) {
            $slick_slider.addClass('noPadRight');
        }
    });


    settings_slider = {
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 99999,
            settings: "unslick"
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            }
        }]
    }
    $slick_slider.slick(settings_slider);

    $(window).on('resize', function () {
        if (!$slick_slider.hasClass('slick-initialized')) {
            return $slick_slider.slick(settings_slider);
        }
    });

    $('.GalleryContent').on('breakpoint', function (event, slick, direction) {
        CreateMenuSlide('.GalleryContent', 'Buttons-Gallery', 'PrevGallery', 'NextGallery');
    });
    CreateMenuSlide('.GalleryContent', 'Buttons-Gallery', 'PrevGallery', 'NextGallery', true);

    /**
        function onMobile() {
            let windowsCheck = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (windowsCheck < 767) {
                $('.GalleryContent').slick({
                    dots: true,
                    arrows: false,
                    infinite: false,
                    slidesToShow: 3,
                    responsive: [{
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 2
                        }
                    }, {
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1
                        }
                    }]
                });
                $('.GalleryContent').on('breakpoint', function (event, slick, direction) {
                    CreateMenuSlide('.GalleryContent', 'Buttons-Gallery', 'PrevGallery', 'NextGallery');
                });
                CreateMenuSlide('.GalleryContent', 'Buttons-Gallery', 'PrevGallery', 'NextGallery', true);
            } else {
                $('.GalleryContent').filter('.slick-initialized').slick('unslick');
            }


        }
        $(window).resize(onMobile).trigger('resize');

     */
    /***********************************************************
    DETAILS
    ***********************************************************/
    $('.CarrouselSensing').on('init', function (event, slick) {
        $(".CarrouselSensing").css("visibility", "visible");
    });
    $('.CarrouselSensing').slick({
        lazyLoad: 'ondemand',
        slidesToShow: 3,
        dots: true,
        arrows: false,
        infinite: false,
        swipe: true,
        responsive: [{
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                dots: true,
            }
        }, {
            breakpoint: 450,
            settings: {
                slidesToShow: 1,
                dots: true,
            }
        }]
    });
    $('.CarrouselSensing').on('breakpoint', function (event, slick, direction) {
        CreateMenuSlide('.CarrouselSensing', 'Buttons-Details', 'PrevDetails', 'NextDetails');
    });
    CreateMenuSlide('.CarrouselSensing', 'Buttons-Details', 'PrevDetails', 'NextDetails', true);
    /***********************************************************
    COMPARE
    ***********************************************************/
    $('.CarrouselCompare').on('init reInit afterChange', function (event, slick) {
        if (slick.slideCount < 3) {
            $(".CarrouselCompare").addClass('noPadRight');
        }
        $(".CarrouselCompare").css("visibility", "visible");
    });

    $('.CarrouselCompare').slick({
        lazyLoad: 'ondemand',
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 769,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }]
    });


    /***********************************************************
        Awards
    ***********************************************************/
    
    
    /***********************************************************
        FUNCTIONS
    ***********************************************************/
    function CreateMenuSlide(Container, Buttons, Prev, Next, Active = false) {
        $(Container + " .slick-dots").wrap('<div class="' + Buttons + ' ButtonsCarrousel" />');
        $("." + Buttons).prepend('<div class="Prev ' + Prev + '"><i class="fas fa-chevron-left"></i></div>');
        $("." + Buttons).append('<div class="Next ' + Next + '"><i class="fas fa-chevron-right"></i></div>');

        if (Active) {
            $(document).on('click', '.' + Prev, function () {
                $(Container).slick("slickPrev");
            });
            $(document).on('click', '.' + Next, function () {
                $(Container).slick("slickNext");
            });
        }
    }
};
